import { getAxiosClient } from "../../axios-client";
import { LoginRequestBody, LoginResponse } from "./types";
const axiosClient = getAxiosClient();
export const login = async (body: LoginRequestBody) => {
  return await axiosClient.ax.post<LoginResponse>("/Account/Login", body);
};
